export default "__VITE_ASSET__9b28382e__"